import { Instance } from 'mobx-state-tree';
import CollectionMapProcessor from '~/mst/models/abstract/collection_map_processor';
import model from './model';

const WidgetsStore = model;

export interface IWidgetsStore extends Instance<typeof WidgetsStore> {}

export default CollectionMapProcessor(WidgetsStore);
